function updateFreeShippingWidget(widget, cart) {
  if (!widget || !cart) return;

  const isEnglish = window.location.pathname.startsWith('/en');
  const isEU = window.location.hostname.endsWith('.eu');
  const isDK = window.location.hostname.endsWith('.dk');

  const locale = isEnglish ? 'en' : 'da';
  const threshold = isEU ? 39500 : 110000;
  const reducedQty = 3;

  const subtotal = cart.items_subtotal_price || 0;
  const realItems = cart.items.filter(item => item.handle !== 'leveringsgebyr');
  const qty = realItems.reduce((sum, item) => sum + item.quantity, 0);

  const fill = widget.querySelector('.progress-fill');
  const message = widget.querySelector('.free-shipping-message');
  const progressBar = widget.querySelector('.progress-bar');

  if (!fill || !message || !progressBar) return;

  let pct = Math.min(100, Math.round((subtotal / threshold) * 100));
  let msg = '';

  if (isEU) {
    if (subtotal >= threshold) {
      msg = "You’ve unlocked free shipping";
      pct = 100;
    } else {
      const amountLeft = (threshold - subtotal) / 100;
      msg = `You're €${amountLeft.toFixed(2)} away from free shipping.`;
    }
  } else {
    const qualifiesByAmount = subtotal >= threshold;
    const qualifiesByQty = qty >= reducedQty;
    const krLeft = (threshold - subtotal) / 100;
    const productsLeft = Math.max(0, reducedQty - qty);

    if (qualifiesByAmount || qualifiesByQty) {
      msg = locale === 'en'
        ? 'Reduced shipping unlocked'
        : 'Du har opnået fragt for kun 29 DKK';
      pct = 100;
    } else if (qty === 0) {
      msg = locale === 'en'
        ? 'Reduced shipping over 1.100 DKK or 3 items'
        : 'Billig fragt over 1.100,00 DKK eller v/3 produkter';
    } else {
      msg = locale === 'en'
        ? `${krLeft.toFixed(2)} DKK or ${productsLeft} item${productsLeft > 1 ? 's' : ''} from reduced shipping`
        : `Du er ${krLeft.toFixed(2).replace('.', ',')} DKK eller ${productsLeft} produkt${productsLeft > 1 ? 'er' : ''} fra at få billig fragt`;
    }
  }

  message.textContent = msg;

  // ✅ Vis/skjul bar og opdater bredde
  if (qty > 0) {
    widget.classList.add('active');
  } else {
    widget.classList.remove('active');
  }

  setTimeout(() => {
    fill.style.width = `${pct}%`;
  }, 0);
}

function initFreeShippingWidgets() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      document.querySelectorAll('[data-widget]').forEach(widget => {
        updateFreeShippingWidget(widget, cart);
      });
    })
    .catch(console.error);
}

document.addEventListener('DOMContentLoaded', initFreeShippingWidgets);
document.addEventListener('theme:cart:change', initFreeShippingWidgets);
document.addEventListener('theme:cart-drawer:open', initFreeShippingWidgets);
